
import getDocument from './get-document';

export default function(node) {
  const _document = getDocument(node);
  return _document.defaultView || window;
}



// WEBPACK FOOTER //
// ./node_modules/ally.js/src/util/get-window.js